module.exports = __webpack_public_path__ + "img/skillsA-2.42bc0bac.png";